<h1 mat-dialog-title>
  Move
  @if (record) {
    @if (!isQuantity && !isText) {
      <strong>{{ record.Catshours }} Hours</strong>
    } @else if (isQuantity) {
      <strong>{{ record.Quantity }} Quantity</strong>
    } @else if (isText) {
      <strong>{{ textDisplayName }}</strong> Text for <strong>{{ textDisplayDay }}</strong>
    }
    @if (activityName !== '') {
      for <strong>{{ activityName }}</strong>
    }
  }

  @if (productionGroup) {
    all records on this Production Group
  }
  to Another Timesheet
</h1>

<mat-dialog-content class="w-[750px]">
  @if (record && record.__isNew) {
    <h3 class="text-center">
      The selected record is not able to be moved because it has not been saved yet.
      <br />
      <span class="text-gray-600"
        >If you recently made changes to this record, try saving it first and then try moving it again</span
      >
    </h3>
  }

  @if (otherTimesheets.length === 0) {
    <h3 class="text-center text-gray-600">
      @if (record) {
        There are no existing timesheets to move this record to
      }
      @if (productionGroup) {
        There are no existing timesheets to move records in this Production Group to
      }
    </h3>
  }

  @if (!record || !record.__isNew) {
    <hr class="my-2" />
    @for (timesheet of otherTimesheets; track timesheet) {
      <div class="mb-2 flex border-b border-gray-300 pb-2">
        <div class="flex shrink-0 flex-col justify-center bg-gray-100 p-4">
          <button mat-raised-button (click)="handleMoveToExistingTimesheetClicked(timesheet.extDoc)">
            <mat-icon svgIcon="move-time" />
            Move Here
          </button>
        </div>
        <div class="flex shrink-0 flex-col items-stretch justify-center bg-gray-100 p-2 text-right">
          <strong class="text-nowrap">Description</strong>
          <strong class="text-nowrap">Timesheet #</strong>
          @for (header of timesheet.headers; track header) {
            <strong class="text-nowrap">{{ header.name }}</strong>
          }
        </div>
        <div class="flex flex-col items-stretch justify-center overflow-hidden p-2">
          <div class="shrink-0 truncate">{{ timesheet.description }}</div>
          <div class="shrink-0 truncate">{{ trimLeadingZeros(timesheet.extDoc.Documentno) }}</div>
          @for (header of timesheet.headers; track header) {
            <div class="shrink-0 truncate" [class.grow]="header.val === ''">
              {{ header.val }}
            </div>
          }
        </div>
      </div>
    }
    <div class="bg-gray-100 p-4">
      <button mat-raised-button (click)="handleMoveToNewTimesheetClicked()">
        <mat-icon svgIcon="move-time" />
        Move to a New Timesheet
      </button>
    </div>
  }
</mat-dialog-content>
